function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.859,
    height: 13.859,
    fill: "none",
    viewBox: "0 0 13.859 13.859",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.7795 0 0 3.7795 -2957.5 10.852)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 784.33,
    cy: -1.0379,
    r: 0.62332,
    style: {
      fillRule: "evenodd",
      fill: "#000",
      paintOrder: "stroke markers fill",
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.33,
    cy: -1.0379,
    r: 1.321,
    style: {
      fill: "none",
      paintOrder: "stroke markers fill",
      stopColor: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 100,
      strokeWidth: 0.39688,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m784.33-2.359v-0.31397",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 0.39688,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m785.65-1.0379h0.31398",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 0.39688,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m784.33 0.28311v0.31398",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 0.39688,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m782.69-1.0379h0.31398",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 0.39688,
      stroke: "#000"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGps);
export default __webpack_public_path__ + "static/media/icon_gps.b932390cb9160b3e227b5ea4ebd51d2c.svg";
export { ForwardRef as ReactComponent };